export default "__VITE_ASSET__CuwEgLud__"